import clsx from 'clsx';
import React from 'react';

interface CustomRadioProps {
  isSelected: boolean;
}

const CustomRadio = ({ isSelected }: CustomRadioProps) => {
  return (
    <span
      className={clsx(
        'flex-none relative mr-8 border border-slate-200 border-solid rounded-full h-28 w-28 after:block bg-white',
        {
          "after:absolute after:top-3 after:left-3 after:h-20 after:w-20 \
              after:content-[''] after:bg-primary-red after:rounded-full": isSelected,
        }
      )}
    ></span>
  );
};

export default CustomRadio;
